import { render } from "./Index.vue?vue&type=template&id=a36dec50"
import script from "./Index.vue?vue&type=script&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&lang=js"
export * from "./Index.vue?vue&type=script&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__